import type { AiDetectionMetricRow } from '../../../../domain/aiDetectionMetrics';

export type SortKey = 'warningRank' | 'name' | 'detectionRuns' | 'infoFlags' | 'warningFlags' | 'warningFlagsPerRun' | 'lastRunAt';
export type SortDirection = 'ascending' | 'descending';

export interface TableSort {
  key: SortKey;
  direction: SortDirection;
}

export function sortMetricRows(rows: AiDetectionMetricRow[], sort: TableSort): AiDetectionMetricRow[] {
  return [...rows].sort((a, b) => {
    const aValue = sort.key === 'lastRunAt' ? a.lastRunAt?.getTime() ?? null : a[sort.key];
    const bValue = sort.key === 'lastRunAt' ? b.lastRunAt?.getTime() ?? null : b[sort.key];
    // Keep missing ranks and dates at the bottom in either direction.
    if (aValue === null) return bValue === null ? 0 : 1;
    if (bValue === null) return -1;
    const comparison = typeof aValue === 'string' && typeof bValue === 'string'
      ? aValue.localeCompare(bValue, undefined, { sensitivity: 'base' })
      : Number(aValue) - Number(bValue);
    return sort.direction === 'ascending' ? comparison : -comparison;
  });
}
